'use client';
var defaultProps = {
    placeholder: "Поиск по сайту",
    fallback: {
        description: "Проверьте запрос и попробуйте ещё раз",
        title: "Ничего не найдено"
    },
    defaultOpened: false
};

export { defaultProps };
